export default __webpack_public_path__ + "static/media/new-qa.1a23e527.png";